import { API_BASE_URL } from "../utils";

const handleUnauthorized = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};

const fetchHandler = async ({ method, endpoint, data }) => {
  const API_BASE_URLS = `${API_BASE_URL}/${endpoint}`;
  const headers = {
    "Content-Type": "application/json",
  };
  const locations = window.location.pathname.split("/");
  const access = localStorage.getItem("usersAccess");
  const accessToken = locations.includes("user")
    ? localStorage.getItem("usersAccess")
    : localStorage.getItem("token");

  console.log(accessToken, "accessToken");

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const options = {
    method,
    headers,
    cache: "no-cache",
    credentials: "same-origin",
  };

  if (method !== "GET" && data) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(API_BASE_URLS, options);

    if (response.status === 401) {
      if (API_BASE_URLS.includes("users")) {
        window.location.href = "/user/login";
      } else {
      }
    }

    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const result = await response.json();
      return { isError: true, data: result };
    }
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      isError: true,
      data: "We can't process your request at this time. Please try later.",
    };
  }
};

export default fetchHandler;

export const fetchHandler2 = async ({ method, endpoint, data }) => {
  const API_BASE_URLS = `${process.env.REACT_APP_API_URL}/${endpoint}`;
  const headers = {
    "Content-Type": "application/json",
  };
  const accessToken = localStorage.getItem("token");
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const options = {
    method,
    headers,
    cache: "no-cache",
    credentials: "same-origin",
  };

  if (method !== "GET" && data) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(API_BASE_URLS, options);

    if (response.status === 401) {
      handleUnauthorized();
      return { isError: true, data: "Unauthorized - Redirecting to login" };
    }

    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      const result = await response.json();
      return { isError: true, data: result };
    }
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      isError: true,
      data: "We can't process your request at this time. Please try later.",
    };
  }
};

export const fetchHandlerForm = async ({ method, endpoint, body }) => {
  const API_BASE_URLS = `${API_BASE_URL}/${endpoint}`;
  const headers = {};
  const accessToken = localStorage.getItem("token");
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const options = {
    method,
    headers,
    cache: "no-cache",
    credentials: "same-origin",
  };

  if (method !== "GET" && body) {
    options.body = body;
  }

  try {
    const response = await fetch(API_BASE_URLS, options);

    if (response.status === 401) {
      handleUnauthorized();
      return { isError: true, data: "Unauthorized - Redirecting to login" };
    }

    if (response.ok) {
      return response; // for FormData, you might not always parse as JSON
    } else {
      const result = await response.json();
      return { isError: true, data: result };
    }
  } catch (error) {
    console.error("Fetch error:", error);
    return {
      isError: true,
      data: "We can't process your request at this time. Please try later.",
    };
  }
};
